import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// ── Generación de PDF del plan FREE — captura visual + watermark ──
// Aislado de cualquier lógica de PDF de los clientes a medida.

const WATERMARK_TEXTO = "WAREHAUSEPLAN · PLAN FREE";

const dibujarWatermark = (doc) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const totalPaginas = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPaginas; i++) {
    doc.setPage(i);
    doc.saveGraphicsState();
    doc.setGState(new doc.GState({ opacity: 0.12 }));
    doc.setFontSize(46);
    doc.setTextColor(120);
    doc.text(WATERMARK_TEXTO, pageWidth / 2, pageHeight / 2, { align: "center", angle: 45 });
    doc.restoreGraphicsState();
  }
};

// elemento: nodo DOM a capturar (el formulario relleno, todavía montado)
// devuelve el objeto jsPDF listo — llamar a .save(nombreArchivo) para descargar
export const generarPdfFree = async (elemento) => {
  const canvas = await html2canvas(elemento, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
  const imgData = canvas.toDataURL("image/png");

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;
  doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    doc.addPage();
    doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  dibujarWatermark(doc);
  return doc;
};

const quitarAcentos = (s) => s
  .replace(/[áàäâã]/g, "a").replace(/[éèëê]/g, "e").replace(/[íìïî]/g, "i")
  .replace(/[óòöôõ]/g, "o").replace(/[úùüû]/g, "u").replace(/ñ/g, "n");

export const nombreArchivoPdfFree = (prefijo, identificador) => {
  const fecha = new Date().toISOString().slice(0, 10);
  const slug = quitarAcentos(String(identificador || "").toLowerCase()).replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  return `${prefijo}${slug ? `_${slug}` : ""}_${fecha}.pdf`;
};
